import { render } from "./AdditionalAnalysis.vue?vue&type=template&id=821bd19a&scoped=true"
import script from "./AdditionalAnalysis.vue?vue&type=script&lang=js"
export * from "./AdditionalAnalysis.vue?vue&type=script&lang=js"

import "./AdditionalAnalysis.vue?vue&type=style&index=0&id=821bd19a&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-821bd19a"]])

export default __exports__